var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_vm.hasEditableFields ? _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('OmniButton', {
    attrs: {
      "isProcessing": _vm.isSavingSomething,
      "disabled": _vm.isSavingSomething,
      "type": "submit",
      "variant": "success",
      "icon": "save",
      "size": "lg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1)]) : _vm._e(), _c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.service-properties.title')) + " ")]), _c('div', {
    staticClass: "row my-2"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-properties.label.property')))])]), _c('div', {
    staticClass: "col-2"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-properties.label.required')))])]), _c('div', {
    staticClass: "col-1"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-properties.label.type')))])]), _c('div', {
    staticClass: "col-5"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('omt.gui.location-management.service-properties.label.value')))])])]), _vm._l(_vm.locationProperties, function (property) {
    return _c('div', {
      key: property.key.id,
      staticClass: "row my-3"
    }, [_c('div', {
      staticClass: "col-3",
      staticStyle: {
        "line-height": "140%"
      },
      domProps: {
        "innerHTML": _vm._s(property.key.display_name)
      }
    }), _c('div', {
      staticClass: "col-1"
    }, [property.key.required ? _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.yes')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.no')))])]), _c('div', {
      staticClass: "col-2"
    }, [_vm._v(_vm._s(_vm._f("dataTypeTranslation")(property.key.data_type)))]), _c('div', {
      staticClass: "col-5"
    }, [property.key.identifier === 'storeImages' ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: property.value,
        expression: "property.value",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "required": property.key.required === 1,
        "readonly": !property.can_edit
      },
      domProps: {
        "value": property.value
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(property, "value", $event.target.value.trim());
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    }), property.can_edit ? _c('form', {
      staticClass: "mt-1",
      attrs: {
        "id": "uploadForm"
      }
    }, [_vm._v(" Foto uploaden "), _c('input', {
      attrs: {
        "type": "file",
        "id": "storeImageFile"
      },
      on: {
        "change": function ($event) {
          return _vm.uploadLocationImage($event, property);
        }
      }
    })]) : _vm._e()]) : property.key.identifier === 'supportsSalesChannels' ? _c('div', [_c('omni-checkboxes', {
      attrs: {
        "options": _vm.salesChannelOmniCheckboxOptions,
        "disabled": !property.can_edit
      },
      model: {
        value: property.value,
        callback: function ($$v) {
          _vm.$set(property, "value", $$v);
        },
        expression: "property.value"
      }
    })], 1) : property.key.data_type === 'int' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: property.value,
        expression: "property.value"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "number",
        "required": property.key.required === 1,
        "readonly": !property.can_edit
      },
      domProps: {
        "value": property.value
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(property, "value", $event.target.value);
        }
      }
    }) : property.key.data_type === 'boolean' ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: property.value,
        expression: "property.value"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "required": property.key.required === 1,
        "disabled": !property.can_edit
      },
      on: {
        "change": function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(property, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.yes')))]), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.label.no')))])]) : property.key.data_type === 'text' ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: property.value,
        expression: "property.value"
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "required": property.key.required === 1,
        "disabled": !property.can_edit
      },
      domProps: {
        "value": property.value
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(property, "value", $event.target.value);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: property.value,
        expression: "property.value",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-control form-control-sm",
      attrs: {
        "type": "text",
        "required": property.key.required === 1,
        "readonly": !property.can_edit
      },
      domProps: {
        "value": property.value
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) return;
          _vm.$set(property, "value", $event.target.value.trim());
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    })])]);
  })], 2), _vm.hasEditableFields ? _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('OmniButton', {
    attrs: {
      "isProcessing": _vm.isSavingSomething,
      "disabled": _vm.isSavingSomething,
      "type": "submit",
      "variant": "success",
      "icon": "save",
      "size": "lg"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.save')) + " ")])], 1)]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }